export default __webpack_public_path__ + "static/Metal_Billboard-7a90d9c83da934e8298b06a9dec6fc3b.png";